import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ProductCard from './ProductCard'
import { PRODUCT_DETAILS } from '../../scenes'
import { api } from '../../../../api/integrationAPI'
import { sendEvent } from '../../../shared/analytics'

const ANIM_OUT_TIMEOUT = 1200

export default class ProductCardContainer extends Component {

  constructor () {
    super()
    this.state = {
      animationState: null,
      selectedOptions: null,
      isShown: false
    }
  }

  componentWillUnmount () {
    if (this.timerId) clearTimeout(this.timerId)
  }

  componentWillReceiveProps (nextProps) {
    let isShown = nextProps.productShown === nextProps.product.id
    this.setState({ isShown })

    if (isShown) { // Animate in
      this.setState({animationState: 'in'})

      if (this.state.selectedOptions === null) {
        let selectedOptions = {} // Preselect first options choices
        if (nextProps.product.details.defaultOptions) {
          selectedOptions = nextProps.product.details.defaultOptions
        } else if (nextProps.product.details.variants) {
          nextProps.product.details.variants.forEach(variant => {
            selectedOptions[variant.id] = variant.options[0].id
          })
        }
        this.setState({selectedOptions})
      }
    }

    if (!isShown && this.state.animationState === 'in') { // Animate out
      this.setState({animationState: 'out'})

      // Clean up after animation
      if (this.timerId) clearTimeout(this.timerId)
      this.timerId = setTimeout(
        () => this.setState({animationState: null}), ANIM_OUT_TIMEOUT
      )
    }
  }

  selectOption = (title, value) => {
    console.log('selectOption', title, value)
    const currentOptions = {...this.state.selectedOptions}
    currentOptions[title] = value
    const availableOptions = api.getAvailableOptions(this.props.product, currentOptions)
    this.setState({ selectedOptions: availableOptions })
  }

  addToCart = (e) => {
    if (this.props.product.details.checkoutUrl) {
      if (this.props.prodMode) sendEvent('Product', 'Redirect to an url')
      window.location.href = this.props.product.details.checkoutUrl
      this.props.closeProduct()
      return
    }

    api.addToCart(this.props.product, this.state.selectedOptions)

    if (this.props.prodMode) sendEvent('Product', 'Add to cart')
    this.setState({animationState: 'cart-in'}, () => {
      setTimeout(() => this.setState({animationState: 'cart-out'}, () => {
        setTimeout(() => this.setState({animationState: null}, () => {
          this.props.closeProduct()
        }), 300)
      }), 2000)
    })
  }

  render () {
    // console.log('ProductCardContainer render')
    let { product, closeProduct, openSettings, closeSettings } = this.props
    let classes = ['ou_product-card']

    if (this.state.animationState === 'in') {
      classes.push('animation-product-card-in')
    }
    if (this.state.animationState === 'out') {
      classes.push('animation-product-card-in', 'animation-product-card-out')
    }

    if (this.state.animationState === 'cart-in') {
      classes.push('animation-product-card-in', 'animation-product-card-cart-status-open')
    } else if (this.state.animationState === 'cart-out') {
      classes.push(
        'animation-product-card-in',
        'animation-product-card-cart-status-open',
        'animation-product-card-cart-status-out'
      )
    } else if (this.props.scene === PRODUCT_DETAILS) {
      classes.push('animation-product-card-settings-open')
    }

    return (
      <ProductCard
        product={product}
        classes={cx(classes)}
        selectedOptions={this.state.selectedOptions}
        selectOption={this.selectOption}
        addToCart={this.addToCart}
        closeProduct={closeProduct}
        openSettings={openSettings}
        closeSettings={closeSettings}
      />
    )
  }
}

ProductCardContainer.propTypes = {
  product: PropTypes.object,
  productShown: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
  scene: PropTypes.string,
  closeProduct: PropTypes.func,
  openSettings: PropTypes.func,
  closeSettings: PropTypes.func,
  prodMode: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/templates/outSide/components/products/ProductCardContainer.js